import { Component, OnInit } from '@angular/core';
import { PatientView } from '../../../model/patient/patient-view';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { WizardStep } from 'src/app/wizard/wizard.component';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { PatientService } from 'src/app/services/patient.service';
import { patientViewValidator } from 'src/app/validators/patient/patient.validator';
import { PatientSearch } from 'src/app/model/patient';
import { BillingOrdenControlWizardService } from '../../../services/billing/billing-orden-control-wizard.service';

@Component({
  selector: 'app-billing-orden-control-patient',
  templateUrl: './billing-orden-control-patient.component.html',
  styleUrls: ['./billing-orden-control-patient.component.css']
})
export class BillingOrdenControlPatientComponent implements OnInit, WizardStep {

  isInit: boolean;
  formGroup: FormGroup;
  patient: PatientView;
  loading: boolean;
  invalidViewResultWeb: boolean;

  constructor(private notificationToastService: NotificationToastService,
    private billingOrdenControlWizardService: BillingOrdenControlWizardService,
    private patientService: PatientService,
    private formBuilder: FormBuilder) {

    this.formGroup = this.formBuilder.group({
      Patient: [null, [ Validators.required, patientViewValidator]]
    });

    this.formGroup.valueChanges.subscribe(() => {
      this.billingOrdenControlWizardService
          .setPatient(this.formGroup.getRawValue().Patient);
    });
  }

  get valid(): boolean {
    return this.completed;
  }


  get completed(): boolean { return !this.formGroup.invalid; }
  get f() { return this.formGroup.controls; }

  save() {
    if (!this.formGroup.invalid) {
    }
  }

  onPatientChange(patientView: PatientView) {
    this.patient = patientView;
    this.formGroup.patchValue({ Patient: this.patient });
  }

  async onPatientSelected(patientSearch: PatientSearch) {
    try {
      this.loading = true;
      this.patient = await this.patientService.getPatientView(patientSearch.Id);
      this.formGroup.patchValue({ Patient: this.patient });
      this.loading = false;
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Control órden');
    } finally {
      this.loading = false;
    }
  }

  async activate() {

  }

  edit(): void {
  }

  async ngOnInit() {
    this.isInit = true;
    try {
      if (this.isInit) {
        this.loading = true;
        this.patient = await this.billingOrdenControlWizardService.getPatient();
        this.formGroup.patchValue({ Patient: this.patient });
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Control órden');
    } finally {
      this.loading = false;
    }
  }
}
